export function reportService(http) {
    const serviceName = "Report";

    return {
        getCartable:(userId,pageNumber,pageSize,sortBy,cartableTypeId,filters) => {

            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))

            // const newfilter= Object.keys(filters).map(key => {
            //     return {
            //         member:key,
            //         operator:filters[key].operator,
            //         value: filters[key].columnType=="number"?Number(filters[key].value):filters[key].value
            //     };
            //   });
            // const filter= cartableTypeId==1
            // ?{
            //     logic:"And",
            //     filters:[
            //         ...newfilter,
            //         {
            //             "member": "IsDone",
            //             "operator": "IsEqualTo",
            //             "value": "false"
            //         },
            //         {
            //             "logic":"Or",
            //             "filters":[
            //             {
            //                 "member": "UserId",
            //                 "operator": "IsEqualTo",
            //                 "value": "619C1E32-63E1-4EC0-A67B-488F44EC402C"
            //             }]
            //         }
            //     ]
            // }
            // :newfilter.length>0 
            //     ?{
            //         logic:"And",
            //         filters:newfilter
            //     }
            //     :null;

            const filter=filters;

            const data = {
                    user:{
                        id:userId
                    },
                    cartableTypeId,
                    dataAttribute:{
                        page:pageNumber,
                        pageSize,
                        sorts:newSortBy.lenght==0?[{member:"AssignId",sortDirection:"Descending"}]:newSortBy,
                        filter:filter
                    }
            };
            return http.post(serviceName + "/GetCartable",data);
        },
        getTaskActivity:(filter)=>{
            const data={
                dataAttribute:{
                    filter
                }
            };

            return http.post(`${serviceName}/GetTaskActivity`,data);
        },
        getTaskActivityToExcel:(filter)=>{
            const data={
                dataAttribute:{
                    filter
                }
            };
            debugger;
            return http.post(`${serviceName}/GetTaskActivityToExcel`,data,{ responseType: "blob" });
        },
        getResponsibleTaskActivity:(filter)=>{
            const data={
                dataAttribute:{
                    filter
                }
            };

            return http.post(serviceName + "/GetResponsibleTaskActivity",data);
        },
        getActivityStatus:(project)=>{
            const data={
                project
            };

            return http.post(serviceName + "/GetActivityStatus",data);
        },
        getActivityStatusExcel:(project)=>{
            const data={
                project
            };

            return http.post(serviceName + "/ActivityStatusToExcel",data,{ responseType: "blob" });
        },
        getQuantityEmployees:(disciplineId,costCenterCode,isCoodinator,isDirectorManagement,isSupervisor)=>{
            const data={
                disciplineId,
                costCenterCode,
                isCoodinator:isCoodinator||false,
                isDirectorManagement:isDirectorManagement||false,
                isSupervisor:isSupervisor||false
            }
            return http.post(`${serviceName}/GetQuantityEmployees`,data);
        },
        getQuantityEmployeesToExcel:(disciplineId,costCenterCode,isCoodinator,isDirectorManagement,isSupervisor)=>{
            const data={
                disciplineId,
                costCenterCode,
                isCoodinator:isCoodinator||false,
                isDirectorManagement:isDirectorManagement||false,
                isSupervisor:isSupervisor||false
            }
            return http.post(`${serviceName}/GetQuantityEmployeesToExcel`,data,{ responseType: "blob" });
        },
        getResponsibleQuantity(userProfileId,responsibleTypeId,categoryType){

            const data={
                ResponsibleQuantity:{
                    userProfileId,
                    responsibleTypeId,
                    categoryType
                }
            }

            return http.post(`${serviceName}/GetResponsibleQuantity`,data);
        },
        getCoordinatorQuantity(userProfileId,categoryType){

            const data={
                CoordinatorQuantity:{
                    userProfileId,
                    categoryType
                }
            }

            return http.post(`${serviceName}/GetCoordinatorQuantity`,data);
        }

    }
}